class NavMenu
{
    constructor ()
    {
        this.siteHeader = document.querySelector( '#site-header' );

        if ( !this.siteHeader )
        {
            return;
        }

        this.btnNavToggler     = this.siteHeader.querySelector( '.btn-nav-toggler' );
        this.btnNavTogglerText = this.btnNavToggler.querySelector( '.btn-nav-toggler-text' );
        this.btnSearchToggler     = this.siteHeader.querySelector( '.btn-search-toggler' );

        this.navMenu = this.siteHeader.querySelector( '.main-nav' );

        this.txtBtnMenuIsOpen   = 'Fermer le menu de navigation';
        this.txtBtnMenuIsClosed = 'Ouvrir le menu de navigation';

        this.stateMenu = 'closed';
        this.stateSearch = 'hidden';

        this.bindEvents();
        this.setupSticky();

        // console.log( "NavMenu is ready" );
    }

    bindEvents ()
    {
        this.btnNavToggler.addEventListener( 'click', this.toggleMenu.bind( this ) );
        this.btnSearchToggler.addEventListener( 'click', this.searchVisible.bind( this ) );
    }


    toggleMenu ()
    {

        if ( 'closed' === this.stateMenu )
        {
            this.showMenu();
        } else
        {
            this.hideMenu();
        }
    }

    showMenu ()
    {

        this.stateMenu = 'open';

        [ this.navMenu, this.btnNavToggler ].forEach( ( el, i ) =>
        {
            el.classList.remove( 'closed' );
            el.classList.add( 'open' );
        } );

        this.navMenu.setAttribute( 'aria-expanded', true );

    }

    hideMenu ()
    {


        this.stateMenu = 'closed';
        [ this.navMenu, this.btnNavToggler ].forEach( ( el, i ) =>
        {
            el.classList.remove( 'open' );
            el.classList.add( 'closed' );
        } );

        this.navMenu.setAttribute( 'aria-expanded', false );

    }


    setupSticky ()
    {
        this.maybeAdjustSticky();

        this.currentlySticky = false;
        window.addEventListener( 'scroll', this.maybeAdjustSticky.bind( this ) );

    }

    searchVisible ()
    {

        if ( 'hidden' === this.stateSearch )
        {
            this.siteHeader.querySelector( '.btn-search-toggler' ).classList.add('active');
            this.siteHeader.querySelector( '.search-bar' ).classList.add('visible');
            this.stateSearch = "visible";

            let txtSearch = document.querySelector("#txt_search");
            setTimeout( () => txtSearch.focus(), 1000);
        }
        else
        {
            this.siteHeader.querySelector( '.btn-search-toggler' ).classList.remove('active');
            this.siteHeader.querySelector( '.search-bar' ).classList.remove('visible');
            this.stateSearch = "hidden";
        }
    }


    maybeAdjustSticky ()
    {
        if ( window.pageYOffset >= 100 )
        {
            if ( !this.currentlySticky )
            {
                this.siteHeader.classList.add( 'sticky' );
                this.currentlySticky = true;
            }

            // no use in re-re-re-re-setying the class
        } else if ( window.pageYOffset < 205 )
        {
            if ( this.currentlySticky )
            {
                this.siteHeader.classList.remove( 'sticky' );
                this.currentlySticky = false;
            }
        }
    }
}


export default new NavMenu();
